import { initRecaptcha } from "@/components/gRecaptcha";
import { initOffcanvasSidebar } from "Components/header";

export function initSidebar() {
  const header = document.querySelector("header.header");

  if (!header) {
    return;
  }

  window.bmgroup20.OffcanvasSidebar = initOffcanvasSidebar(
    header,
    initRecapthaOnSidebarFormFirstOpen
  );
}

const initRecapthaOnSidebarFormFirstOpen = (firstOpen = false) =>
  firstOpen &&
  document.body?.classList.contains("with--recaptcha") &&
  initRecaptcha();
